import { inject, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Combustibles } from '@/app/models/Combustibles';
import { Estaciones } from '@/app/models/Estaciones';
import { AlmacenesService } from '@/app/services/almacenes.service';
import { CombustiblesService } from '@/app/services/combustibles.service';
import { EstacionesService } from '@/app/services/estaciones.service';
import { EstatusService } from '@/app/services/estatus.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-editar-almacen',
    templateUrl: './editar-almacen.component.html',
    styleUrls: ['./editar-almacen.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditarAlmacenComponent {
  private spinner = inject(NgxSpinnerService);

  //model 
  AlmacenRQ = {
    idAlmacen: '',
    idEstacion: '',
    descripcion: '',
    idCombustible: '',
    idEstatus: '',
    idSite: '',
    codigo: '',
    activo: false,
    creadoPor: '',
  }

  //catalogos
  estaciones: Estaciones[] =[];
  combustibles: Combustibles[] = [];
  estatusCatalog: any[] = [];

    //Bandera global para cerrar el modal
    hasFinished: boolean = false;
  
    constructor
    (
      private almacenesService: AlmacenesService,
      private estacionesService: EstacionesService,
      private combustiblesService: CombustiblesService,
      private toastr: ToastrService, 
      private router: Router,
      public dialogRef: MatDialogRef<EditarAlmacenComponent>,
      private estatusService: EstatusService,
      private userTokenReaderService: TokenReaderService,
      @Inject(MAT_DIALOG_DATA) public data: any
    )
    {
      this.getEstaciones();
      this.getEstatus();
      this.obtenerCombustibles();

      let {
        idAlmacen,
        idEstacion,
        descripcion,
        idCombustible,
        idEstatus,
        idSite,
        codigo,
        activo,
      } = data;
  
      //console.log('idAlmacen :>> ', idAlmacen);
      this.AlmacenRQ.idAlmacen = idAlmacen;
      this.AlmacenRQ.idEstacion = idEstacion;
      this.AlmacenRQ.descripcion = descripcion;
      this.AlmacenRQ.idCombustible = idCombustible;
      this.AlmacenRQ.idEstatus = idEstatus;
      this.AlmacenRQ.idSite = idSite; 
      this.AlmacenRQ.codigo = codigo;
      this.AlmacenRQ.activo = activo;

    }

    getEstaciones(){
      this.estacionesService.obtenerEstaciones().subscribe({
        next: (data: any)=>{
          if(data != null && data.Estaciones != null && Array.isArray(data.Estaciones) && data.Estaciones.length > 0){

            this.estaciones = data.Estaciones.map( (i: any) => {return {'label': i.IATA, 'value': i.IATA} } );    
            
            if(this.AlmacenRQ.idEstacion === null){

              this.AlmacenRQ.idEstacion = data.Estaciones[0].IATA;
            }

          }else{
            this.estaciones = [];
            this.AlmacenRQ.idEstacion = '';
          }
        },
        error: (err) =>{
          this.spinner.hide();
          
          if(err.status == 401){
            this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
            this.router.navigate(['/login']);
          }else{
            if(err.error){
              let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
            }
          }
          console.log(err);
        }
      });
    }

    getEstatus(){
      this.estatusService.getEstatus().subscribe({
        next: (data: any)=>{
          if(data != null && data.Estatus != null && Array.isArray(data.Estatus) && data.Estatus.length > 0){
            this.estatusCatalog = data.Estatus
              .filter( (x: any) => x['AplicaAlmacen'] === 'True' || x['AplicaAlmacen'] == 1)
              .map( (i: any) => {return {'label': i.estatus, 'value': i.estatus} } );    
          }else{
            this.estatusCatalog = [];
            this.AlmacenRQ.idEstatus = '';
          }
        },
        error: (err) =>{
          this.spinner.hide();
          if(err.status == 401){
            this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
            this.router.navigate(['/login']);
          }else{
            if(err.error){
              let { ClassInfo } = err.error;
              this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
            }
          }
          console.log(err);
        }
      });
    }

    obtenerCombustibles(){
      this.combustiblesService.obtenerCombustibles().subscribe({
        next: (data: any)=>{

          if(data != null && data.Combustible != null && data.Combustible.length > 0){

            this.combustibles = data.Combustible.map( (i: any) => {return {'label': i.tipo, 'value': i.tipo} } );    
            
          }else{
            this.combustibles = [];
            this.AlmacenRQ.idCombustible = '';
          }
  
        },
        error: (err) =>{
          this.spinner.hide();
          
          if(err.status == 401){
            this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
            this.router.navigate(['/login']);
          }else{
            if(err.error){
              let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
            }
          }
          console.log(err);
        }
      });
    }

  //Submit y crear almacen
  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas actualizar este almacén?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.updateAlmacenes();
        }
      });
    }
  }

  updateAlmacenes(){
    this.spinner.show();
    //Pendiente: asignar creao por desde token
    this.AlmacenRQ.creadoPor = this.userTokenReaderService.getUserData().idUsuario;
    
    this.almacenesService.updateAlmacenes(this.AlmacenRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Almacén actualizado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se han guardado los cambios. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }
}
